export default {
  "root": "_root_145ya_1",
  "value": "_value_145ya_1",
  "--duration": "_--duration_145ya_1",
  "--size-small": "_--size-small_145ya_1",
  "--size-medium": "_--size-medium_145ya_1",
  "--color-primary": "_--color-primary_145ya_1",
  "--color-critical": "_--color-critical_145ya_1",
  "--color-warning": "_--color-warning_145ya_1",
  "--color-positive": "_--color-positive_145ya_1",
  "--color-media": "_--color-media_145ya_1"
};import "ni:sha-256;zvIx3SCtTCtTG4Rnbsn5CxyTV9Y0oNfhDT-zZSu465w";